import React from 'react';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import ProjectRow from './ProjectRow';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import scrollIcon from '../../../../assets/images/document-scroll-2.svg';
import TableHeader from '../../../../components/Table/TableHeader';
import TableRow from '../../../../components/Table/TableRow';
import { DOCUMENTS, INVENTORY, CLOSEOUT_HISTORY, PROGRESS_REPORTS } from '../../../../constants/TabConstants';
import './AttachmentsTable.scss';

export default class AttachmentsTable extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: {},
    };
    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    const { projects, projectsListOnly } = this.props;

    if (projectsListOnly) {
      return;
    }
    if (projects) {
      projects.forEach(project => {
        this.sortDocsAndSetFirstAttachment(project, true);
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { toggleSelected } = this.props;
    if (toggleSelected != prevProps.toggleSelected) {
      this.setState({ selectedProjects: {}, selectedAttachments: {}, selectedAttachment: null });  
    }
  }

  handleCheckAll(checked) {
    let viewing = this.props.viewing;
    let { selectAll } = this.state;
    if (this.props.projects) {
      this.props.projects.filter(project => {
        if (!checked && this.state.projectsChecked && this.state.projectsChecked[viewing] && this.state.projectsChecked[viewing][project.id]) {
          delete this.state.projectsChecked[viewing][project.id];
        } else if (checked) {
          if (!this.state.projectsChecked) {
            this.state.projectsChecked = {};
          }
          if (!this.state.projectsChecked[viewing]) {
            this.state.projectsChecked[viewing] = {};
          }
          this.state.projectsChecked[viewing][project.id] = project;
        }
        let docs = viewing == DOCUMENTS ? project.documents : viewing == CLOSEOUT_HISTORY ? project.all_closeouts : viewing == PROGRESS_REPORTS ? this.props.progressReports : project.inventory_items;
        if (docs) {
          docs.filter(attachment => {
            if (
              !checked &&
              this.state.attachmentsChecked &&
              this.state.attachmentsChecked[viewing] &&
              this.state.attachmentsChecked[viewing][attachment.id]
            ) {
              delete this.state.attachmentsChecked[viewing][attachment.id];
            } else if (checked && !attachment.status) {
              if (!this.state.attachmentsChecked) {
                this.state.attachmentsChecked = {};
              }
              if (!this.state.attachmentsChecked[viewing]) {
                this.state.attachmentsChecked[viewing] = {};
              }
              this.state.attachmentsChecked[viewing][attachment.id] = project;
            }
            return true;
          });
        }
        return true;
      });
    }
    selectAll[viewing] = !selectAll[viewing];
    this.setState({
      selectAll: selectAll,
      selectionChanged: !this.state.selectionChanged,
    });
  }

  sortDocsAndSetFirstAttachment(project, setState) {
    const { viewing, progressReports } = this.props;
    let completionDocs;
    if (viewing == DOCUMENTS) {
      completionDocs = !project.documents ? [] : project.documents.filter(cd => {
        return true;
      });
      completionDocs.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        } else if (c1.created_at > c2.created_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else if (viewing == CLOSEOUT_HISTORY) {
      // filter out in progress closeout history (for now)...
      completionDocs = !project.all_closeouts ? [] : project.all_closeouts.filter((cd) => { return !(cd.status == 1);});
      completionDocs.sort((c1, c2) => {
        if (c1.updated_at < c2.updated_at) {
          return 1;
        } else if (c1.updated_at > c2.updated_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else if (viewing == PROGRESS_REPORTS) {
      // filter out in progress reports (status == 'in_progress')
      completionDocs = !progressReports ? [] : progressReports.filter((pr) => { return pr.status != 'in_progress'; });
      completionDocs.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        } else if (c1.created_at > c2.created_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else if (viewing == INVENTORY) {
      completionDocs = project.inventory_items.filter(cd => {
        return true;
      });
      completionDocs.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        } else if (c1.created_at > c2.created_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    if (viewing != INVENTORY && !this.firstAttachment && !this.state.selectedAttachment) {
      this.firstAttachment = completionDocs[0] || null;

      if (setState) {
        this.handleAttachmentSelected(this.firstAttachment, true);
      }

    }
    return completionDocs;
  }

  handleSelectProjectAttachments(select, project, selectedProjects) {
    let viewing = this.props.viewing;
    let { selectedAttachments } = this.state;
    if (!selectedAttachments) {
      selectedAttachments = {};
    }
    let attachments = null;
    if (viewing == DOCUMENTS) {
      attachments = project.documents;
    }
    else if (viewing == CLOSEOUT_HISTORY) {
      attachments = project.all_closeouts;
    }
    else if (viewing == PROGRESS_REPORTS) {
      attachments = this.props.progressReports;
    }
    else if (viewing == INVENTORY) {
      attachments = project.inventory_items;
    }
    if (attachments) {
      attachments.forEach(attachment => {
        if (!select && selectedAttachments[attachment.id]) {
          delete selectedAttachments[attachment.id];
        }
        else if (select) {
          selectedAttachments[attachment.id] = attachment;
        }
      });
    }
    this.setState({ selectedAttachments });
    if (this.props.handleSelectForExport) {
      this.props.handleSelectForExport(selectedProjects, selectedAttachments);
    }
  }

  handleMultiSelect(select, project) {
    let { selectedProjects } = this.state;
    if (project) {
      if (!selectedProjects) {
        selectedProjects = {};
      }
      if (!select && selectedProjects[project.id]) {
        delete selectedProjects[project.id];
      }
      else if (select) {
        selectedProjects[project.id] = project;
      }
      this.handleSelectProjectAttachments(select, project, selectedProjects);
      this.setState({ selectedProjects });
    }
  }

  handleChecked(attachment, checked, project) {
    let { selectedAttachments, selectedProjects } = this.state;
    if (!selectedAttachments) {
      selectedAttachments = {};
    }
    if (!checked && selectedAttachments[attachment.id]) {
      delete selectedAttachments[attachment.id];
      if (project && selectedProjects) {
        delete selectedProjects[project.id];
      }
    }
    else if (checked) {
      selectedAttachments[attachment.id] = attachment;
    }
    this.setState({ selectedAttachments });
    if (this.props.handleSelectForExport) {
      this.props.handleSelectForExport(this.state.selectedProjects, selectedAttachments);
    }

  }

  handleAttachmentSelected(selectedAttachment, isSelected) {
    if (!this.state.selectedAttachment || (this.state.selectedAttachment &&
      (!selectedAttachment || (selectedAttachment && selectedAttachment.id != this.state.selectedAttachment.id)))) {
      this.setState({ selectedAttachment });
      if (this.props.handleSelectAttachment) {
        this.props.handleSelectAttachment(selectedAttachment);
      }
    }
  }
  
  handleSort(sortField, direction) {
    const ascending = direction == 'up';
    if (sortField != this.state.sortField || ascending != this.state.ascending) {
      this.setState({ sortField, ascending });
    }
  }

  createTableHeader(project) {
    // Create header

    const { viewing } = this.props;
    let caretTypes = [];
    if (viewing == DOCUMENTS) {
      caretTypes = [
        { type: 'name', headerName: 'DOCUMENT FILE NAME', first: true }, 
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'UPLOADED BY' },
        { type: 'created_at', headerName: 'DATE UPLOADED' },
      ];
    }
    else if (viewing == CLOSEOUT_HISTORY) {
      caretTypes = [
        { type: 'name', headerName: 'CLOSEOUT FILE NAME', first: true }, 
        { type: 'closeoutable_type', headerName: 'CLOSEOUT TYPE' },
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'USER' },
        { type: 'created_at', headerName: 'DATE GENERATED' },
      ];
    }
    else if (viewing == PROGRESS_REPORTS) {
      caretTypes = [
        { type: 'name', headerName: 'REPORT FILE NAME', first: true }, 
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'GENERATED BY' },
        { type: 'created_at', headerName: 'DATE GENERATED' },
      ];
    }
    else if (viewing == INVENTORY) {
      caretTypes = [
        { type: 'identifier', headerName: 'INVENTORY ID', first: true }, 
        { type: 'name', headerName: 'INVENTORY NAME' }, 
        { type: 'user', headerName: 'ADDED BY' },
        { type: 'created_at', headerName: 'ENTRY DATE' },
        { type: 'tasks', headerName: 'TASK ATTACHED TO' },
      ];
    }

    const accent = this.props.currentCompany && this.props.currentCompany.accent_color ? this.props.currentCompany.accent_color : '#CD043A';
    const sortDirectionClass = this.state.ascending ? '' : 'down';

    return (
      <TableHeader 
        accent={ accent } 
        caretTypes={ caretTypes } 
        sortDirectionClass={sortDirectionClass}
        reportType={viewing == INVENTORY ? 'inventory' : 'attachment'}
        hasMultiSelect={false}
        hasMultiSelectFirst={viewing == INVENTORY ? false : true}
        handleMultiSelect={this.handleMultiSelect}
        item={project}
        multiSelectEnabled={this.state.selectedProjects ? !!this.state.selectedProjects[project.id] : false}
      />
    );
  }

  createTableContent(attachments, project) {
    // Create rows
    let isEvenRow = false;

    const { selectedAttachment } = this.state;
    const { viewing } = this.props;
    const tableRows = attachments.map((attachment, index) => {
      isEvenRow = !isEvenRow;
      let selected = false;
      if (selectedAttachment && selectedAttachment.id == attachment.id) {
        selected = true;
      }
      return (
        <TableRow
          key={viewing + '_' + attachment.id}
          even={isEvenRow}
          selectedItem={attachment}
          parentItem={project}
          type={viewing == DOCUMENTS ? 'attachment' : viewing == CLOSEOUT_HISTORY ? 'attachment' : viewing == PROGRESS_REPORTS ? 'attachment' : 'inventory'}
          hasNarrowCheckBox={viewing == INVENTORY ? false : true}
          checked={this.handleChecked}
          select={this.handleAttachmentSelected}
          rowSelected={selected}
          isSelected={this.state.selectedAttachments ? !!this.state.selectedAttachments[attachment.id] : false}
        />
      );
    });
    return <div className={'attachment-scroller'}>  
    <div className='attachment-rows' ref={(element) => {
      this.list = element;
    }}>
      {tableRows}
    </div>
  </div>;  

  }

  createProjectDocumentsList(project) {
    let viewing = this.props.viewing;
    const noDocumentsFound = this.props.noDocumentsFound;
    let attachmentsHeader = this.createTableHeader(project);
    if (noDocumentsFound) {
      let error;
      if (viewing == DOCUMENTS) {
        error = 'No Documents found.';
      }
      else if (viewing == CLOSEOUT_HISTORY) {
        error = 'No Closeouts found.';
      }
      else if (viewing == PROGRESS_REPORTS) {
        error = 'No Progress Reports found.';
      }
      else if (viewing == INVENTORY) {
        error = 'No Inventory available.';
      }
      const attachments = (
        <div className="empty-project-row" key={'empty-row-' + project.id}>
          {error}
        </div>
      );
      return <div className={'attachments-table'}>
      {attachmentsHeader}  
      {attachments}
    </div>;
    }
    else {
      const completionDocs = this.sortDocsAndSetFirstAttachment(project, false);
      const attachments = this.createTableContent(completionDocs, project);
      return <div className={'attachments-table'}>
          {attachmentsHeader}  
          {attachments}
      </div>;
    }
  }

  handleGoToProject(project) {
    if (this.props.gotoProject) {
      this.props.gotoProject(project);
    }
  }

  createProjectsList() {
    const { projects, projectsListOnly, viewing, progressReports } = this.props;
    let projectAttachments = [];
    if (!projects) {
      return projectAttachments;
    }

    if (projectsListOnly) {
      const sorted = [...projects].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
      );
      sorted.forEach((project) => {
        projectAttachments.push(
          <div className="projects-list" key={'project-row-' + project.id}>
            <ProjectRow
              project={project}
              viewing={viewing}
              gotoProject={this.handleGoToProject}
              gotoProjectList={this.props.gotoProjectList}
            />
          </div>
        );
      });
      this.firstAttachment = null;
      return projectAttachments;
    }

    projects.forEach(project => {
      let empty = null;
      if (
        (viewing == DOCUMENTS && (!project.documents || !project.documents.length)) ||
        (viewing == CLOSEOUT_HISTORY && (!project.all_closeouts || !project.all_closeouts.length)) ||
        (viewing == PROGRESS_REPORTS && (!progressReports || !progressReports.length)) ||
        (viewing == INVENTORY && (!project.inventory_items || !project.inventory_items.length))
      ) {
        empty = 'empty';
      }
      if (
        (viewing == DOCUMENTS && project.documents) ||
        (viewing == CLOSEOUT_HISTORY && project.all_closeouts) ||
        (viewing == PROGRESS_REPORTS && progressReports) ||
        (viewing == INVENTORY && project.inventory_items)
      ) {
        const projectDocuments = this.createProjectDocumentsList(project);
        projectAttachments.push(
          <div className={`projects-list ${empty}`} key={'project-row-' + project.id}>
            <ProjectRow
              project={project}
              viewing={viewing}
              gotoProject={this.handleGoToProject}
            />
            {projectDocuments}
          </div>
        );
      }
    });
    this.firstAttachment = null;
    return projectAttachments;
  }

  handleDownload() {
    this.setState({ attachmentsChecked: [], selectAll: {}, projectsChecked: [] });
    if (this.props.viewing == CLOSEOUT_HISTORY) {
      this.analyticsLogger.logCloseoutDocument('CloseoutDocumentDownloadedPOR');
    }
  }

  render() {
    const { attachmentsChecked } = this.state;
    const { projectsListOnly, listEmptyTitle } = this.props;
    let viewing = this.props.viewing;
    // TODO new component
    const projectAttachments = this.createProjectsList();
    let selected = [];
    if (attachmentsChecked && attachmentsChecked[viewing]) {
      for (let key in attachmentsChecked[viewing]) {
        if (key) {
          selected.push(key);
        }
      }
    }
    const emptyTitle = projectsListOnly && listEmptyTitle
      ? listEmptyTitle
      : viewing === DOCUMENTS
        ? 'No Documents found.'
        : viewing === CLOSEOUT_HISTORY
          ? 'No Closeouts found.'
          : viewing === PROGRESS_REPORTS
            ? 'No Progress Reports found.'
            : viewing === INVENTORY
              ? 'No Inventory available.'
              : 'No Documents found.';

    return (
      <div className={'attachments-table--wrapper' + (projectsListOnly ? ' attachments-table--wrapper--projects-list-only' : '')}>
        {projectAttachments.length ? (
          <div className="attachments-table-interior">
            {projectAttachments}
          </div>
        ) : (
          <div className="attachments-table-interior--empty">
            <img src={scrollIcon} alt="document placeholder" />
            <p className="attachments-table-interior--empty--title">{emptyTitle}</p>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORProjectDocuments/AttachmentsTable/index.js